module.exports = __webpack_public_path__ + "static/img/h9.247408a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h9.jpg
// module id = Vq/m
// module chunks = 0